(function( $ ) {
    var images = document.querySelectorAll('.kg-gallery-image img');
    images.forEach(function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    })
    var galleryContainers = document.querySelectorAll('.kg-gallery-container')
    if (galleryContainers.length) {
      window.mediumZoom('.kg-gallery-image > img', {
        margin: 10,
        background: 'rgba(0,0,0,0.9)'
      })
    }
    window.mediumZoom('.kg-image-card > img', {
      margin: 10,
      background: 'rgba(0,0,0,0.9)'
    })
})( jQuery );
